/**
 * GitHub site URL
 */
export const GH_URL = 'https://github.com';
/**
 * GitHub API root URL
 */
export const GH_ROOT_URL = 'https://api.github.com';
